import React, { FC } from 'react';

export const Pencil: FC = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.914 6a.997.997 0 0 0-.707.293L14 7.5l2.5 2.5 1.207-1.207a1 1 0 0 0 0-1.414l-1.086-1.086A.997.997 0 0 0 15.914 6ZM13 8.5l-5.87 5.87s.459-.041.63.13c.17.171.03 1.29.24 1.5.21.21 1.322.062 1.481.222.16.16.149.648.149.648L15.5 11 13 8.5ZM6.5 16l-.472 1.336A.5.5 0 0 0 6.5 18c.056 0 .111-.01.164-.028l.005-.002.013-.004.003-.002L8 17.5l-.75-.75L6.5 16Z"
      fill="currentColor"
    />
  </svg>
);
